import httpService from "V2.0/services/httpService";
const endPoint = "/bulkCampaigns";

function getBulkCampaigns({ workspaceId }) {
  return httpService.get(`${endPoint}/whiteLabelGetBulkCampaigns/${workspaceId}`);
}

function postBulkCampaigns({ workspaceId, payload }) {
  return httpService.post(
    `${endPoint}/whiteLabelCreateBulkCampaign/${workspaceId}`,
    payload,
  );
}

function getBulkCampaignStatistics({ workspaceId, bulkCampaignId }) {
  return httpService.get(
    `${endPoint}/whiteLabelGetBulkCampaignStatistics/${workspaceId}/${bulkCampaignId}`,
  );
}

function getBulkCampaignObjects({ workspaceId, bulkCampaignId }) {
  return httpService.get(
    `${endPoint}/whiteLabelGetBulkCampaigns/${workspaceId}/${bulkCampaignId}`,
  );
}

function getBulkCampaignObjectsPaginated({
  workspaceId,
  bulkCampaignId,
  params,
}) {
  return httpService.get(
    `${endPoint}/whiteLabelGetBulkCampaignObjectsPaginated/${workspaceId}/${bulkCampaignId}`,
    {
      params,
    },
  );
}

function deleteBulkCampaign({ workspaceId, bulkCampaignId }) {
  return httpService.delete(
    `${endPoint}/whiteLabelDeleteBulkCampaign/${workspaceId}/${bulkCampaignId}`,
  );
}

function downloadBulkCampaign({ workspaceId, bulkCampaignId }) {
  return httpService.get(
    `${endPoint}/whiteLabelDownloadBulkCampaignData/${workspaceId}/${bulkCampaignId}`,
  );
}

function postResumeBulkCampaign({
  workspaceId,
  bulkCampaignId,
}: {
  workspaceId: string;
  bulkCampaignId: string;
}) {
  return httpService.post(
    `${endPoint}/whiteLabelResumeBulkCampaign/${workspaceId}/${bulkCampaignId}`,
  );
}

function postPauseBulkCampaign({
  workspaceId,
  bulkCampaignId,
}: {
  workspaceId: string;
  bulkCampaignId: string;
}) {
  return httpService.post(
    `${endPoint}/whiteLabelPauseBulkCampaign/${workspaceId}/${bulkCampaignId}`,
  );
}

function postCancelBulkCampaign({
  workspaceId,
  bulkCampaignId,
}: {
  workspaceId: string;
  bulkCampaignId: string;
}) {
  return httpService.post(
    `${endPoint}/whiteLabelCancelBulkCampaign/${workspaceId}/${bulkCampaignId}`,
  );
}

export {
  getBulkCampaigns,
  postBulkCampaigns,
  getBulkCampaignStatistics,
  getBulkCampaignObjects,
  getBulkCampaignObjectsPaginated,
  deleteBulkCampaign,
  downloadBulkCampaign,
  postPauseBulkCampaign,
  postResumeBulkCampaign,
  postCancelBulkCampaign
};
